import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth } from 'react-oidc-context';

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallbackRoute
});

/**
 * Handles the authentication callback route logic.
 * This function checks the authentication state and redirects authenticated users to their intended destination or a default route.
 * If there is an authentication error and the authentication process is not loading, it throws the error.
 */
function AuthCallbackRoute() {
  // TODO: detect &error= and &error_description in the URL and show an error page
  const auth = useAuth();

  if (auth.isAuthenticated) {
    const redirectTo = (auth.user?.state as any)?.redirectTo || '/';

    return <Navigate to={redirectTo} replace={true} />;
  }

  if (!auth.isLoading && auth.error) {
    throw auth.error;
  }

  return <></>;
}
